import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Moment from "react-moment";
import { getAlert } from "../Services/appAlerts";
import { useDispatch, useSelector } from "react-redux";
import { acceptSheduleMeeting, getMeetingAcceptStatus, sendSheduleMeetingLinks } from "../app/store/candidate";

const MEETING_OPTIONS_STYLES = {
  modalContent: {
    borderRadius: "26px",
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)",
  },
  modalDialog: {
    maxWidth: "920px",
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)",
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px",
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  headerIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "15px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(79, 70, 229, 0.16) 100%)",
    color: "#4338ca",
    fontSize: "21px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)",
  },
  title: {
    fontSize: "22px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0,
  },
  subtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px",
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 800,
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)",
    flexShrink: 0,
  },
  modalBody: {
    padding: "20px 22px 22px 22px",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
  },
  helperCard: {
    borderRadius: "16px",
    padding: "16px",
    background: "linear-gradient(135deg, rgba(248,250,252,0.98) 0%, rgba(239,246,255,0.9) 100%)",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    marginBottom: "16px",
  },
  helperTitle: {
    fontSize: "14px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "8px",
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.7,
    color: "#64748b",
    margin: 0,
  },
  sectionCard: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "18px",
    marginBottom: "16px",
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginBottom: "14px",
  },
  sectionTitle: {
    fontSize: "15px",
    fontWeight: 800,
    color: "#0f172a",
    margin: 0,
  },
  sectionSubtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px",
  },
  countPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "7px 11px",
    fontSize: "12px",
    fontWeight: 800,
  },
  optionGrid: {
    display: "grid",
    gap: "12px",
  },
  optionCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "14px",
    borderRadius: "18px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    padding: "14px 16px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    width: "100%",
    textAlign: "left",
  },
  optionCardSelected: {
    borderColor: "rgba(59, 130, 246, 0.65)",
    background: "linear-gradient(135deg, rgba(239,246,255,0.98) 0%, rgba(255,255,255,1) 100%)",
    boxShadow: "0 12px 24px rgba(37, 99, 235, 0.09)",
  },
  optionMain: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minWidth: 0,
  },
  radioMark: {
    width: "22px",
    height: "22px",
    borderRadius: "999px",
    border: "2px solid rgba(148, 163, 184, 0.8)",
    background: "#ffffff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  radioMarkSelected: {
    borderColor: "#2563eb",
    background: "#2563eb",
    color: "#ffffff",
  },
  dateIcon: {
    width: "38px",
    height: "38px",
    borderRadius: "14px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f8fbff",
    color: "#4338ca",
    border: "1px solid rgba(226, 232, 240, 1)",
    flexShrink: 0,
  },
  optionDate: {
    display: "block",
    fontSize: "14px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.35,
  },
  optionTime: {
    display: "block",
    fontSize: "12px",
    color: "#64748b",
    marginTop: "3px",
  },
  selectedPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    borderRadius: "999px",
    background: "#dcfce7",
    color: "#166534",
    border: "1px solid rgba(187, 247, 208, 1)",
    padding: "6px 10px",
    fontSize: "12px",
    fontWeight: 800,
    flexShrink: 0,
  },
  emptyState: {
    padding: "34px 20px",
    textAlign: "center",
    color: "#64748b",
    fontSize: "13px",
  },
  footerActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
  },
  cancelButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#475569",
    padding: "10px 14px",
    fontSize: "12px",
    fontWeight: 800,
  },
  saveButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "none",
    background: "linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)",
    color: "#ffffff",
    padding: "10px 16px",
    fontSize: "12px",
    fontWeight: 800,
    boxShadow: "0 14px 28px rgba(79, 70, 229, 0.2)",
  },
  disabledButton: {
    opacity: 0.55,
    boxShadow: "none",
    cursor: "not-allowed",
  },
};

const MeetingOptions = (props) => {
  const { meetingShowHide, handleMeetingModalShowHide, meeting } = props;
  const [selectedOption, setSelectedOption] = useState("");

  const meetingAcceptStatusSelector = useSelector(getMeetingAcceptStatus);

  const dispatch = useDispatch();
  const meetingOptions = meeting?.options || [];

  useEffect(() => {
    const acceptedOption = meetingOptions.find((option) => option.status === true);
    setSelectedOption(acceptedOption || "");
  }, [meeting]);

  const handleMeetingAccept = (opt) => {
    setSelectedOption(opt);
  };

  const doSubmit = () => {
    dispatch(acceptSheduleMeeting(selectedOption));
  };

  useEffect(() => {
    if (meetingAcceptStatusSelector) {
      getAlert("", "Accepted Successfully", "success");
      if (selectedOption) {
        dispatch(sendSheduleMeetingLinks(selectedOption.optionId));
      }

      handleMeetingModalShowHide("save");
    }
  }, [meetingAcceptStatusSelector]);

  return (
    <Modal
      show={meetingShowHide}
      size="xl"
      centered
      onHide={handleMeetingModalShowHide}
      dialogClassName="meeting-options-modal-dialog"
      contentClassName="meeting-options-modal-content"
    >
      <style>{`
        .meeting-options-modal-dialog {
          max-width: ${MEETING_OPTIONS_STYLES.modalDialog.maxWidth};
        }
        .meeting-options-modal-content {
          border-radius: ${MEETING_OPTIONS_STYLES.modalContent.borderRadius};
          overflow: ${MEETING_OPTIONS_STYLES.modalContent.overflow};
          border: ${MEETING_OPTIONS_STYLES.modalContent.border};
          box-shadow: ${MEETING_OPTIONS_STYLES.modalContent.boxShadow};
        }
        .meeting-option-card:hover {
          transform: translateY(-1px);
          box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
        }
      `}</style>
      <Modal.Header style={MEETING_OPTIONS_STYLES.modalHeader}>
        <div style={MEETING_OPTIONS_STYLES.headerContent}>
          <Modal.Title as="div" style={MEETING_OPTIONS_STYLES.titleWrap}>
            <div style={MEETING_OPTIONS_STYLES.headerIcon}>
              <i className="fa fa-calendar-check-o" aria-hidden="true"></i>
            </div>
            <div>
              <div style={MEETING_OPTIONS_STYLES.title}>Schedule Appointment Options</div>
              <div style={MEETING_OPTIONS_STYLES.subtitle}>
                Choose the appointment time that works best for this application.
              </div>
            </div>
          </Modal.Title>
          <button
            type="button"
            style={MEETING_OPTIONS_STYLES.closeButton}
            onClick={handleMeetingModalShowHide}
            aria-label="Close meeting options"
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </Modal.Header>

      <Modal.Body style={MEETING_OPTIONS_STYLES.modalBody}>
        <div style={MEETING_OPTIONS_STYLES.helperCard}>
          <div style={MEETING_OPTIONS_STYLES.helperTitle}>Appointment selection</div>
          <p style={MEETING_OPTIONS_STYLES.helperText}>
            Review the proposed time slots below. Select one option and save to confirm your appointment.
          </p>
        </div>

        <div style={MEETING_OPTIONS_STYLES.sectionCard}>
          <div style={MEETING_OPTIONS_STYLES.sectionHeader}>
            <div>
              <div style={MEETING_OPTIONS_STYLES.sectionTitle}>Available Time Slots</div>
              <div style={MEETING_OPTIONS_STYLES.sectionSubtitle}>
                {meetingOptions.length} option{meetingOptions.length === 1 ? "" : "s"} proposed
              </div>
            </div>
            <span style={MEETING_OPTIONS_STYLES.countPill}>
              <i className="fa fa-clock-o" aria-hidden="true"></i>
              Select one
            </span>
          </div>

          <div style={MEETING_OPTIONS_STYLES.optionGrid}>
            {meetingOptions.length > 0 ? meetingOptions.map((option, key) => {
              const isSelected = selectedOption?.optionId === option.optionId;

              return (
                <button
                  type="button"
                  key={option.optionId || key}
                  className="meeting-option-card"
                  style={{
                    ...MEETING_OPTIONS_STYLES.optionCard,
                    ...(isSelected ? MEETING_OPTIONS_STYLES.optionCardSelected : {}),
                  }}
                  onClick={() => handleMeetingAccept(option)}
                >
                  <span style={MEETING_OPTIONS_STYLES.optionMain}>
                    <span
                      style={{
                        ...MEETING_OPTIONS_STYLES.radioMark,
                        ...(isSelected ? MEETING_OPTIONS_STYLES.radioMarkSelected : {}),
                      }}
                    >
                      {isSelected && <i className="fa fa-check" aria-hidden="true"></i>}
                    </span>
                    <span style={MEETING_OPTIONS_STYLES.dateIcon}>
                      <i className="fa fa-calendar-o" aria-hidden="true"></i>
                    </span>
                    <span>
                      <span style={MEETING_OPTIONS_STYLES.optionDate}>
                        <Moment format="MMM Do YYYY">{option.meetingDate}</Moment>
                      </span>
                      <span style={MEETING_OPTIONS_STYLES.optionTime}>
                        {option.startTime} - {option.endTime}
                      </span>
                    </span>
                  </span>
                  {isSelected && (
                    <span style={MEETING_OPTIONS_STYLES.selectedPill}>
                      <i className="fa fa-check-circle" aria-hidden="true"></i>
                      Selected
                    </span>
                  )}
                </button>
              );
            }) : (
              <div style={MEETING_OPTIONS_STYLES.emptyState}>
                <i className="fa fa-calendar-o fa-3x mb-3 d-block opacity-2"></i>
                No appointment options are available.
              </div>
            )}
          </div>
        </div>

        <div style={MEETING_OPTIONS_STYLES.footerActions}>
          <button
            type="button"
            style={MEETING_OPTIONS_STYLES.cancelButton}
            onClick={handleMeetingModalShowHide}
          >
            <i className="fa fa-times" aria-hidden="true"></i>
            Cancel
          </button>
          <button
            type="button"
            style={{
              ...MEETING_OPTIONS_STYLES.saveButton,
              ...(!selectedOption ? MEETING_OPTIONS_STYLES.disabledButton : {}),
            }}
            disabled={!selectedOption}
            onClick={doSubmit}
          >
            <i className="fa fa-check" aria-hidden="true"></i>
            Save Selection
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MeetingOptions;
